import {Component, inject, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {GtNgDatepickerModule} from "../../../shared/commons/gt-ng-datepicker/gt-ng-datepicker.module";
import {NgbPagination} from "@ng-bootstrap/ng-bootstrap";
import {NotFoundComponent} from "../../../shared/not-found/not-found.component";
import {SharedCommonModule} from "../../../shared/commons/shared-common.module";
import {Page, UserData, UserLk2TokenDto} from "../../../../generated-model/model";
import {UserLk2TokenResource} from "../../../service/UserLk2TokenResource";
import {PageRequest, TokenType} from "../../../app.constants";
import {Lk2Resource} from "../../../service/Lk2Resource";
import {ActivatedRoute} from "@angular/router";
import {AlertDialogComponent} from "../../../shared/commons/dialog/alert-dialog/alert-dialog.component";
import {AlertDialogService} from "../../../shared/commons/dialog/alert-dialog/alert-dialog.service";
import {AuthenService} from "../../../security/authen.service";
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-lk2-token',
  standalone: true,
  imports: [
    FormsModule,
    GtNgDatepickerModule,
    NgbPagination,
    NotFoundComponent,
    ReactiveFormsModule,
    SharedCommonModule,
    NgClass
  ],
  templateUrl: './lk2-token.component.html',
  styleUrl: './lk2-token.component.scss'
})
export class Lk2TokenComponent implements OnInit {
  pageData: Page<UserLk2TokenDto> = {size: 10};
  userLk2TokenResource = inject(UserLk2TokenResource);
  lk2Resource = inject(Lk2Resource);
  activatedRoute = inject(ActivatedRoute);
  alertDialogService = inject(AlertDialogService);
  authenService = inject(AuthenService);
  principal: (UserData & { name?: string, userId?: number });
  TokenType = TokenType;

  constructor() {
    this.activatedRoute.queryParams.subscribe(params => {
      let thaiDError = params['thaid_error'];
      if (thaiDError && thaiDError === 'personal_id_not_match') {
        this.alertDialogService.open({content: `ข้อมูลไม่ถูกต้อง!! เลขประจำตัวประชาชนไม่ตรงกับผู้ใช้งาน`})
      }
    });
    this.authenService.user$().subscribe({
      next: e => {
        this.principal = e
      }
    });
  }

  ngOnInit(): void {
    this.search();
  }

  search(page: number = 1) {
    const pageRequest: PageRequest = {page: page - 1, size: this.pageData.size}
    this.userLk2TokenResource.batchToken(pageRequest).subscribe({
      next: e => {
        this.pageData = e;
      }
    })
  }

  add() {
    this.lk2Resource.getConsentLk2().subscribe({
      next: e => {
        window.location.href = e;
      }
    });
  }
}
